import styled from "styled-components";
import { Colors } from "../../config";
import Box from "../Box";

const HeaderButtonsBox = ({
  activeCell,
  handleClick,
  confirmFlightLocationUrl,
  requestId,
  isBusinessTrip = false,
}) => {
  return (
    <Box boxColor={Colors.linkWater} boxBorder="0.375rem">
      <Wrapper>
        <HeadingWrapper>
          <RequestSummaryHeader>Request Summary -&nbsp;</RequestSummaryHeader>
          <RequestIDWrapper>Request ID&nbsp;{requestId}</RequestIDWrapper>
          <RequestIDMobile>{requestId}</RequestIDMobile>
          {isBusinessTrip && <BusinessTrip>Business Trip</BusinessTrip>}
        </HeadingWrapper>
        <FilterContainer>
          <FilterItem active={activeCell === 2} onClick={() => handleClick(2)}>
            Traveller Details
          </FilterItem>
          <FilterItem active={activeCell === 3} onClick={() => handleClick(3)}>
            {confirmFlightLocationUrl ? "" : "Joury Details"}
          </FilterItem>
        </FilterContainer>
      </Wrapper>
    </Box>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.5rem 0.75rem 1.25rem;
  flex-wrap: wrap; // allow wrapping on small screens
  gap: 0.5rem;

  @media only screen and (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const HeadingWrapper = styled.div`
  font-weight: 700;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;

  @media only screen and (max-width: 480px) {
    font-size: 1.125rem;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media only screen and (max-width: 768px) {
    display: none; // show on mobile if desired
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
  }
`;

const FilterItem = styled.div`
  color: ${(props) => (props.active ? Colors.white : Colors.martinique)};
  background: ${(props) => props.active && Colors.darkBlue};
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 2rem;
  padding: 0 1rem;
  border-radius: 1rem;
  cursor: pointer;
  transition: color 0.2s;

  @media only screen and (max-width: 480px) {
    font-size: 0.7rem;
    line-height: 1.5rem;
    padding: 0 0.75rem;
  }
`;

const RequestSummaryHeader = styled.div`
  color: ${Colors.sharkApprox};
  display: inline-block;
  @media only screen and (max-width: 480px) {
    font-size: 0.875rem;
  }
`;

const RequestIDMobile = styled.div`
  color: ${Colors.brandOne};
  font-size: 0.875rem;
  @media only screen and (min-width: 481px) {
    display: none;
  }
`;

const RequestIDWrapper = styled.div`
  color: ${Colors.brandOne};
  display: inline-block;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const BusinessTrip = styled.div`
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 4px;
  background: #fad56f;
  margin-left: 8px;
  font-weight: 400;

  @media only screen and (max-width: 480px) {
    margin-left: 0;
    margin-top: 4px;
  }
`;

export default HeaderButtonsBox;
